import { AwesomeSezzle } from "typings/awesomeSezzle";
import "./Sezzle.scss";

export class Sezzle
{
	static Sdk: typeof AwesomeSezzle;
	static InfoLink: HTMLElement;
	static ModalObserver: MutationObserver;
	static WidgetElement: HTMLElement;
	static WidgetInstance: AwesomeSezzle;

	static BindInformationLink = (element?: HTMLElement): void =>
	{
		Sezzle.InfoLink = element;
		Sezzle.InfoLink.addEventListener("click", Sezzle.DisplayInformation);
	};

	static DisplayInformation = (e?: Event): void =>
	{
		if (typeof e !== "undefined")
		{
			e.preventDefault();
		}

		if (typeof Sezzle.Sdk === "undefined")
		{
			Sezzle.InitializeSdk().
				then(() =>
				{
					Sezzle.DisplayInformation();
					return;
				});
		}
		else
		{
			Sezzle.OpenModal();
		}
	};

	static HideModal(): void
	{
		document.body.classList.remove("sezzle-modal-open");
		Sezzle.ModalObserver.disconnect();
	}

	static InitializeSdk = async (e?: Event): Promise<void> =>
	{
		if (typeof e !== "undefined")
		{
			e.preventDefault();
		}

		try
		{
			const sezzleSdk = await import(/* webpackChunkName: "AwesomeSezzle" */ "@sezzle/sezzle-static-widget");
			Sezzle.Sdk = sezzleSdk.default;
			const widget = document.createElement("div");
			widget.id = "sezzle-widget";
			widget.setAttribute("style", "display: none !important;");
			document.body.appendChild(widget);

			Sezzle.WidgetElement = document.querySelector("#sezzle-widget");

			Sezzle.WidgetInstance = new Sezzle.Sdk({
				amount: "40.00",
				renderElement: "sezzle-widget"
			});

			Sezzle.WidgetInstance.init();
		}
		catch (error)
		{
			console.log("Failed to load Sezzle SDK:", error);
		}
	};

	static OpenModal = (): void =>
	{
		if (typeof Sezzle.ModalObserver === "undefined")
		{
			Sezzle.ModalObserver = new MutationObserver(Sezzle.HideModal.bind(Sezzle));
		}

		const modalNode: HTMLElement = document.querySelector(".sezzle-checkout-modal-lightbox");
		modalNode.style.display = "block";
		document.body.classList.add("sezzle-modal-open");

		Sezzle.ModalObserver.observe(modalNode, {
			attributes: true,
			attributeFilter: ["style"]
		});
	};
}

if (typeof window.Fun.ThirdParty === "undefined")
{
	window.Fun.ThirdParty = { Sezzle: Sezzle };
}